import React from 'react';

import CardHOC from './Components/CardHOC';
import OpenChoice from '../../Types/Components/OpenChoice';

export default function (props) {
  return <CardHOC question={props.question}>
    <OpenChoice {...props} />
  </CardHOC>
}